#import "./TimestampsFull.graphql"
#import "./SearchIndexFull.graphql"

fragment VoucherFull on Voucher {
  id
  code
  type
  recipient {
    email
    emailSent
  }
  validTo
  paidByUserId
  restrictedForUserId
  usedByUserId
  usedByOrderId
  value {
    type
    maxAbsolute
    percentageValue
    absolute
  }
  cancelledAt
  cancelledBy
  usedAtBranchAt
  usedAtBranchBy
  ...TimestampsFull
  ...SearchIndexFull
}
